import Image from 'next/image'
import Link from 'next/link'

interface Props {
  headline: string,
  text: string,
  url: string,
  image: {
    src: string,
    alt: string,
    width: number,
    height: number,
  }
}

export const Article:  React.FunctionComponent<Props> = (props) => {
  const {
    headline,
    text,
    url,
    image
  } = props;

  return (
    <Link href={ url }>
      <a target='_blank'>
        <div className='article'>
          <div className='article__image-container'>
            <Image
              src={ image.src }
              alt={ image.alt }
              width={ image.width }
              height={ image.height }
              blurDataURL={ image.src }
              placeholder='blur'
              className='article__image'
              layout='responsive'
            />
          </div>
          <div className='article__body'>
            <h2 className='article__title font--lg font--primary'>
              { headline }
            </h2>
            <p className='article__text'>
              { text }
            </p>
            <div className='article__arrow' />
          </div>
        </div>
      </a>
    </Link>
  )
}